var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97762 0.822183C7.4072 1.25176 7.4072 1.94824 6.97762 2.37782L3.35544 6L6.97762 9.62218C7.4072 10.0518 7.4072 10.7482 6.97762 11.1778C6.54804 11.6074 5.85156 11.6074 5.42199 11.1778L1.02199 6.77782C0.59241 6.34824 0.59241 5.65176 1.02199 5.22218L5.42199 0.822182C5.85156 0.392606 6.54805 0.392606 6.97762 0.822183Z",
    fill: "#59B8AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.23ec00ca.svg";
export { ForwardRef as ReactComponent };